import React, { useCallback, useRef, useState } from "react";
import { connect } from "react-redux";
import "../../../../../om/css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    HeaderFilter,
    SearchPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";

const ByLocationResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "b3f7c1d9-2e64-4a80-9c15-7d2a6f0b93e2";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);

    const onSelectionChanged = ({ selectedRowsData }) => {
        if (props.onLocationSelected) {
            props.onLocationSelected(selectedRowsData[0]);
        }
    };

    return (
        <div style={{ height: '100%' }}>
            <DataGrid
                onExporting={(e) => {
                    if (window.handleDevExtremeDataGridExport) {
                        window.handleDevExtremeDataGridExport(e);
                    }
                }}
                ref={dataGrid}
                height="100%"
                dataSource={props.data}
                keyExpr="RowId"
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                remoteOperations={true}
                columnAutoWidth={true}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser enabled={true} title="Choose Column" width={290} height={290} sortOrder="asc">
                    <ColumnChooserSearch enabled={true} editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager visible={true} showPageSizeSelector={true} allowedPageSizes={allowedPageSizes} showNavigationButtons={true} />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <HeaderFilter visible={true} />
                <SearchPanel visible={true} width={240} placeholder="Search..." />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring enabled={true} type="custom" customLoad={loadState} storageKey={gridKey} customSave={saveState} />
                <Column dataField="IdentityId" caption="Warehouse" sortOrder="asc" />
                <Column dataField="LocationCode" caption="Location" />
                <Column dataField="Description" caption="Description" />
                <Column dataField="MinPositionIndex" caption="Min Position Index" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="MaxPositionIndex" caption="Max Position Index" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="CapacityAreaLimitFlag" caption="Area" visible={false} />
                <Column dataField="CapacityArea" caption="Capacity Area" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="CapacityUnits" caption="Capacity Units" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="CapacityVolume" caption="Capacity Volume" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="ClassCode" caption="Class" visible={false} />
                <Column dataField="SubClassCode" caption="Sub Class" visible={false} />
                <Column dataField="UserDefinedCode1" caption="Code 1" visible={false} />
                <Column dataField="UserDefinedCode2" caption="Code 2" visible={false} />
                <Column dataField="UserDefinedCode3" caption="Code 3" visible={false} />
                <Column dataField="UserDefinedCode4" caption="Code 4" visible={false} />
                <Column dataField="UserDefinedCode5" caption="Code 5" visible={false} />
                <Column dataField="UserDefinedCode6" caption="Code 6" visible={false} />
                <Column dataField="UserDefinedCode7" caption="Code 7" visible={false} />
                <Column dataField="UserDefinedCode8" caption="Code 8" visible={false} />
                <Column dataField="UserDefinedCode9" caption="Code 9" visible={false} />
                <Column dataField="UserDefinedCode10" caption="Code 10" visible={false} />
                <Column dataField="CreationUserId" caption="Creation By" visible={false} />
                <Column dataField="CreationDateTime" caption="Creation Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="UserDefinedDate1" caption="Date 1" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="UserDefinedDate2" caption="Date 2" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="UserDefinedDate3" caption="Date 3" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="UserDefinedDate4" caption="Date 4" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="UserDefinedDate5" caption="Date 5" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="UserDefinedDate6" caption="Date 6" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="UserDefinedDate7" caption="Date 7" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="UserDefinedDate8" caption="Date 8" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="UserDefinedDate9" caption="Date 9" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="UserDefinedDate10" caption="Date 10" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="Depth" caption="Depth" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="Dimensions" caption="Dimensions" visible={false} />
                <Column dataField="Height" caption="Height" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="LastUpdatedDateTime" caption="Last Updated Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="LastUpdateUserId" caption="Last Update By" visible={false} />
                <Column dataField="LocationType" caption="Location Type" visible={false} />
                <Column dataField="MinimumUnits" caption="Minimum Units" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="MaximumUnits" caption="Maximum Units" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="ParentLocation" caption="Parent Location" visible={false} />
                <Column dataField="ParentLocationDescription" caption="Parent Location Description" visible={false} />
                <Column dataField="CapacityPieces" caption="Pieces" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="ProfileCode" caption="Profile" visible={false} />
                <Column dataField="UserDefinedQuantity1" caption="Quantity 1" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="UserDefinedQuantity2" caption="Quantity 2" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="UserDefinedQuantity3" caption="Quantity 3" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="UserDefinedQuantity4" caption="Quantity 4" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="UserDefinedQuantity5" caption="Quantity 5" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="UserDefinedQuantity6" caption="Quantity 6" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="UserDefinedQuantity7" caption="Quantity 7" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="UserDefinedQuantity8" caption="Quantity 8" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="UserDefinedQuantity9" caption="Quantity 9" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="UserDefinedQuantity10" caption="Quantity 10" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="Record" caption="Record#" visible={false} />
                <Column dataField="UserDefinedReference1" caption="Reference 1" visible={false} />
                <Column dataField="UserDefinedReference2" caption="Reference 2" visible={false} />
                <Column dataField="UserDefinedReference3" caption="Reference 3" visible={false} />
                <Column dataField="UserDefinedReference4" caption="Reference 4" visible={false} />
                <Column dataField="UserDefinedReference5" caption="Reference 5" visible={false} />
                <Column dataField="UserDefinedReference6" caption="Reference 6" visible={false} />
                <Column dataField="UserDefinedReference7" caption="Reference 7" visible={false} />
                <Column dataField="UserDefinedReference8" caption="Reference 8" visible={false} />
                <Column dataField="UserDefinedReference9" caption="Reference 9" visible={false} />
                <Column dataField="UserDefinedReference10" caption="Reference 10" visible={false} />
                <Column dataField="Status" caption="Status" visible={false} />
                <Column dataField="Width" caption="Width" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="CapacityContainerUnits" caption="Capacity Container Units" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="CapacityShippingUnits" caption="Capacity Shipping Units" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="CapacityGrossWeight" caption="Capacity Gross Weight" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="CapacityNetWeight" caption="Capacity Net Weight" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="Priority" caption="Priority" visible={false} />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ByLocationResult);
